import { useCallback, type ReactNode, type ReactPortal } from "react";
import { createPortal } from "react-dom";

/**
 * Mount floating UI into `document.body` or a custom root so it is not clipped
 * by table cells / `overflow: hidden` (e.g. `getContainer={() => document.body}`).
 *
 * Pass a **stable** `getContainer` (e.g. from `useCallback`) if it closes over props.
 */
export function usePortal(getContainer?: () => HTMLElement | null) {
  return useCallback(
    (children: ReactNode): ReactPortal | null => {
      if (typeof document === "undefined") {
        return null;
      }
      const root = getContainer?.() ?? document.body;
      if (!root) {
        return null;
      }
      return createPortal(children, root);
    },
    [getContainer]
  );
}
